import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CabinetHomeGettingStartedComponent } from './cabinet-home-getting-started.component';

/** @deprecated Use CabinetHomeGettingStartedComponent directly. */
@Component({
  selector: 'lib-cabinet-home-command-center',
  imports: [CabinetHomeGettingStartedComponent],
  template: `<lib-cabinet-home-getting-started />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CabinetHomeCommandCenterComponent {}
